import { combineLatest, map, type Observable } from 'rxjs';
import type { APISurveyAttributes } from '@ardoq/api-types';
import type { TourId } from '@ardoq/product-tours';
import { answerSurveysTourSurvey$ } from './answerSurveys/answerSurveysTourSurvey$';
import {
  type FallbackComponentTypeForTour,
  loadedFallbackComponentTypeForTour$,
} from './fallbackComponentTypeForTour';

type TourData = {
  answerSurveysTourSurvey: APISurveyAttributes | null;
  fallbackComponentType: FallbackComponentTypeForTour | null;
};

const COMPONENT_TYPE_GATED_TOUR_IDS: readonly TourId[] = [
  'data-inventory',
  'data-inventory-whats-new-2026-10',
  'component-overview',
];

/**
 * The data-gated tours whose data is there, as the catalogue's `requiresTourData`
 * asks for it.
 */
const toToursWithSatisfiedDataGates = ({
  answerSurveysTourSurvey,
  fallbackComponentType,
}: TourData): readonly TourId[] => [
  ...(answerSurveysTourSurvey ? (['answer-surveys'] as const) : []),
  ...(fallbackComponentType ? COMPONENT_TYPE_GATED_TOUR_IDS : []),
];

export const toursWithSatisfiedDataGates$: Observable<readonly TourId[]> =
  combineLatest({
    answerSurveysTourSurvey: answerSurveysTourSurvey$,
    fallbackComponentType: loadedFallbackComponentTypeForTour$,
  }).pipe(map(toToursWithSatisfiedDataGates));
